import { I18n } from '@calendly/i18n';
import { PackageIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextStandard } from '@calendly/ui/theme';
import { iconWrapperCss, Row } from './styles';
const primaryInviteeActionButtonCss = "p2cjdbd";
const lineCss = "l1ocft1u";
export const MeetingPackageContactRow = ({
  packageInfo,
  viewPackage
}) => {
  if (!packageInfo && !viewPackage) {
    return null;
  }
  return <Row>
      <span className={iconWrapperCss}>
        <PackageIcon spacingRight={0} />
      </span>
      <div className={lineCss}>
        {packageInfo && packageInfo.fulfilled != null && packageInfo.total != null && <BodyText size="medium" color={colorTextStandard} as="span">
            {I18n.t('publisher.meetings.meeting_package.sessions_progress', {
          fulfilled: packageInfo.fulfilled,
          total: packageInfo.total
        })}
          </BodyText>}
        {viewPackage && <MinimalButton className={primaryInviteeActionButtonCss} onClick={viewPackage} type="button">
            {I18n.t('publisher.meetings.meeting_package.view_package')}
          </MinimalButton>}
      </div>
    </Row>;
};

require("./meeting_package_contact_row.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_package_contact_row.js");